import React from 'react'

import { Icon } from '@fourthwall/components'
import { CloseIcon } from '@fourthwall/icons'

import * as S from './RemoveModificationButton.styled'

type RemoveModificationButtonProps = {
  ariaLabel?: string
  onClick: () => void
}

export const RemoveModificationButton = ({ ariaLabel, onClick }: RemoveModificationButtonProps) => {
  return (
    <S.Button type="button" aria-label={ariaLabel} onClick={onClick}>
      <S.RemoveIcon>
        <Icon component={CloseIcon} height={10} />
      </S.RemoveIcon>
    </S.Button>
  )
}
